export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["favicon.png"]),
	mimeTypes: {".png":"image/png"},
	_: {
		client: {start:"_app/immutable/entry/start.CmeA6zS0.js",app:"_app/immutable/entry/app.BiaYB3NM.js",imports:["_app/immutable/entry/start.CmeA6zS0.js","_app/immutable/chunks/BtLIKGb6.js","_app/immutable/chunks/Bw-sSNj3.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/D0nJw_1J.js","_app/immutable/entry/app.BiaYB3NM.js","_app/immutable/chunks/Bw-sSNj3.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/DVg7NvZA.js","_app/immutable/chunks/CUJb9yOj.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/D0nJw_1J.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js'))
		],
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			},
			{
				id: "/prueba",
				pattern: /^\/prueba\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			},
			{
				id: "/test2",
				pattern: /^\/test2\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 4 },
				endpoint: null
			},
			{
				id: "/test2/[slug]",
				pattern: /^\/test2\/([^/]+?)\/?$/,
				params: [{"name":"slug","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,], errors: [1,], leaf: 5 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";